module.exports = {"apiBaseUrl":"https://api.development.capitolairships.com/","flinkLibraryUrl":"https://api.development.capitolairships.com/client.js"}


//////////////////
// WEBPACK FOOTER
// ./src/lib/config/config.development.json
// module id = tTI2
// module chunks = 1